"use strict";
// Flex display classes are contained in ./Display.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexAlignSelf = exports.FlexGap = exports.FlexShrink = exports.FlexGrow = exports.FlexWrap = exports.FlexDirection = exports.FlexJustifySelf = exports.FlexJustifyItems = exports.FlexJustifyContent = exports.FlexAlignContent = exports.FlexAlignItems = void 0;
var FlexAlignItems;
(function (FlexAlignItems) {
    FlexAlignItems["Start"] = "u-align-items-start";
    FlexAlignItems["End"] = "u-align-items-end";
    FlexAlignItems["Center"] = "u-align-items-center";
    FlexAlignItems["Stretch"] = "u-align-items-stretch";
})(FlexAlignItems = exports.FlexAlignItems || (exports.FlexAlignItems = {}));
var FlexAlignContent;
(function (FlexAlignContent) {
    FlexAlignContent["Start"] = "u-align-content-start";
    FlexAlignContent["Center"] = "u-align-content-center";
    FlexAlignContent["End"] = "u-align-content-end";
    FlexAlignContent["Stretch"] = "u-align-content-stretch";
    FlexAlignContent["Around"] = "u-align-content-around";
    FlexAlignContent["Between"] = "u-align-content-between";
    FlexAlignContent["Evenly"] = "u-align-content-evenly";
})(FlexAlignContent = exports.FlexAlignContent || (exports.FlexAlignContent = {}));
var FlexJustifyContent;
(function (FlexJustifyContent) {
    FlexJustifyContent["Start"] = "u-justify-content-start";
    FlexJustifyContent["Center"] = "u-justify-content-center";
    FlexJustifyContent["End"] = "u-justify-content-end";
    FlexJustifyContent["Stretch"] = "u-justify-content-stretch";
    FlexJustifyContent["Around"] = "u-justify-content-around";
    FlexJustifyContent["Between"] = "u-justify-content-between";
})(FlexJustifyContent = exports.FlexJustifyContent || (exports.FlexJustifyContent = {}));
var FlexJustifyItems;
(function (FlexJustifyItems) {
    FlexJustifyItems["Start"] = "u-justify-items-start";
    FlexJustifyItems["Center"] = "u-justify-items-center";
    FlexJustifyItems["End"] = "u-justify-items-end";
    FlexJustifyItems["Stretch"] = "u-justify-items-stretch";
})(FlexJustifyItems = exports.FlexJustifyItems || (exports.FlexJustifyItems = {}));
var FlexJustifySelf;
(function (FlexJustifySelf) {
    FlexJustifySelf["Start"] = "u-justify-self-start";
    FlexJustifySelf["Center"] = "u-justify-self-center";
    FlexJustifySelf["End"] = "u-justify-self-end";
    FlexJustifySelf["Stretch"] = "u-justify-self-stretch";
})(FlexJustifySelf = exports.FlexJustifySelf || (exports.FlexJustifySelf = {}));
var FlexDirection;
(function (FlexDirection) {
    FlexDirection["Column"] = "u-flex-dir-col";
    FlexDirection["ColumnReverse"] = "u-flex-dir-col-rev";
    FlexDirection["Row"] = "u-flex-dir-row";
    FlexDirection["RowReverse"] = "u-flex-dir-row-rev";
})(FlexDirection = exports.FlexDirection || (exports.FlexDirection = {}));
var FlexWrap;
(function (FlexWrap) {
    FlexWrap["None"] = "u-flex-wrap-none";
    FlexWrap["Wrap"] = "u-flex-wrap";
    FlexWrap["Reverse"] = "u-flex-wrap-rev";
})(FlexWrap = exports.FlexWrap || (exports.FlexWrap = {}));
var FlexGrow;
(function (FlexGrow) {
    FlexGrow["GrowZero"] = "u-flex-grow-0";
    FlexGrow["GrowOne"] = "u-flex-grow-1";
    FlexGrow["GrowTwo"] = "u-flex-grow-2";
})(FlexGrow = exports.FlexGrow || (exports.FlexGrow = {}));
var FlexShrink;
(function (FlexShrink) {
    FlexShrink["ShrinkZero"] = "u-flex-shrink-0";
    FlexShrink["ShrinkOne"] = "u-flex-shrink-1";
})(FlexShrink = exports.FlexShrink || (exports.FlexShrink = {}));
var FlexGap;
(function (FlexGap) {
    FlexGap["Normal"] = "u-gap";
    FlexGap["Rows"] = "u-gap-rows";
    FlexGap["Columns"] = "u-gap-cols";
    FlexGap["Double"] = "u-gap-double";
    FlexGap["Half"] = "u-gap-half";
    FlexGap["Zero"] = "u-gap-zero";
})(FlexGap = exports.FlexGap || (exports.FlexGap = {}));
var FlexAlignSelf;
(function (FlexAlignSelf) {
    FlexAlignSelf["Start"] = "u-align-self-start";
    FlexAlignSelf["End"] = "u-align-self-end";
    FlexAlignSelf["Center"] = "u-align-self-center";
    FlexAlignSelf["Stretch"] = "u-align-self-stretch";
})(FlexAlignSelf = exports.FlexAlignSelf || (exports.FlexAlignSelf = {}));
//# sourceMappingURL=Flex.js.map